<template>
  <div class="sel-categoria-game">
    <multiselect
      v-model="categorias_selected"
      :disabled="isDisabled"
      :required="isRequired"
      :loading="isLoading"
      :multiple="isMulti"
      :allowEmpty="true"
      :options="options"
      selectedLabel="«"
      deselectLabel=""
      selectLabel=""
      placeholder=""
      :hide-selected="isHideSelected"
      @input="selectChange"
    >
      <template slot="noResult">
        <span>{{ $t('Nenhum elemento encontrado') }}.</span>
      </template>
      <template slot="noOptions">
        <span>{{ $t('Nenhum dado foi retornado') }}.</span>
      </template>
      <template slot="placeholder">
        <span>{{ $t(emptyLabel) }}</span>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: {
    categorias: {
      type: String,
      default: ''
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    emptyLabel: {
      type: String,
      default: ''
    },
    includeAll: {
      type: Boolean,
      default: false
    },
    isMulti: {
      type: Boolean,
      default: false
    },
    isHideSelected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      categorias_selected: null,
      options: [],
      isLoading: false,
      label_todos: this.$t('Todas')
    };
  },
  mounted() {
    this.setOptions();
  },
  methods: {
    selectChange() {
      // Manter compatibilidade com uso antigo
      this.$emit('changeCategoria', this.categorias_selected ? this.categorias_selected.toString() : '');

      // Novo formato para validações
      if (this.categorias_selected == null) {
        this.$emit('selectChange', 'categoria', null);
        return;
      }
      if (this.isMulti) {
        // Para múltipla seleção, retornar array de objetos
        const selectedObjects = this.categorias_selected.map((cat) => ({ nome: cat }));
        this.$emit('selectChange', 'categoria', selectedObjects);
      } else {
        // Para seleção única, retornar objeto
        this.$emit('selectChange', 'categoria', { nome: this.categorias_selected });
      }
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('tipo_categoria_game', {
          columns: 'nome',
          filter: `business_logic.localidade_web.id_empresa = ${this.$util.getIdEmpresa()}`
        })
        .then((res) => {
          this.isLoading = false;
          this.options = res.data.map((cat) => cat.nome);
          if (this.includeAll == true) {
            this.options.unshift(this.label_todos);
          }
          this.setSelecteds();
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
          this.options = [];
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: `${err.code} - ${err.message}`,
            msgTranslate: false,
            type: 'error'
          });
        });
    },
    setSelecteds() {
      if (this.categorias && typeof this.categorias === 'string') {
        if (this.categorias.includes(',')) {
          let categorias_array = this.categorias.split(',');
          this.categorias_selected = categorias_array;
        } else {
          this.categorias_selected = this.isMulti == true ? [this.categorias] : this.categorias;
        }

        // Removendo opções duplicadas e incluindo opções já selecionadas que não são existentes no banco
        this.options = Array.from(new Set([...this.options, ...this.categorias_selected]));
      }
    }
  }
};
</script>

<style lang="scss">
.sel-categoria-game {
  .multiselect:not(.multiselect--active) {
    .multiselect__tags {
      display: flex !important;
    }
  }
  .multiselect__tag {
    background: #26b4ff;
  }
}
</style>
